export const GET = 'GET';
export const POST = 'POST';


// WEBPACK FOOTER //
// ./src/api/constants.js